import { createFileRoute } from "@tanstack/react-router";
import { useArticlesQuery } from "@/api/queries";
import { LegalQueueList } from "@/components/legal/legal-queue-list";
import { Navbar } from "@/components/navbar";
import { filterLegalQueueStories, groupLegalStories } from "@/utils/legal-queue";

export const Route = createFileRoute("/_auth-init-space/_authorized/legal/")({
  component: LegalQueuePage,
});

const navbar = <Navbar title="Legal queue" showActions={false} />;

function LegalQueuePage() {
  const { data, isLoading, isError } = useArticlesQuery({ limit: 100 });

  if (isLoading) {
    return (
      <div className="flex flex-col flex-1">
        {navbar}
        <div className="flex flex-1 justify-center items-start mt-(--navbar-height)">
          <div className="container py-8">
            <p className="text-sm text-muted-foreground">Loading…</p>
          </div>
        </div>
      </div>
    );
  }

  if (isError) {
    return (
      <div className="flex flex-col flex-1">
        {navbar}
        <div className="flex flex-1 justify-center items-start mt-(--navbar-height)">
          <div className="container py-8">
            <p className="text-destructive">Failed to load the legal queue. Please refresh the page.</p>
          </div>
        </div>
      </div>
    );
  }

  // TODO(OBS-1018): Once created_at is available on APIArticle, scope this to the last 7 days instead of relying on a fixed limit.
  const stories = data?.results ?? [];
  const filtered = filterLegalQueueStories(stories);
  const grouped = groupLegalStories(filtered);

  return (
    <div className="flex flex-col flex-1">
      {navbar}
      <div className="flex flex-1 items-start mt-(--navbar-height)">
        <div className="w-full py-8 px-6">
          <LegalQueueList grouped={grouped} />
        </div>
      </div>
    </div>
  );
}
